import React from 'react';

interface PayloadType {
  coordinates: string;
}

type PayloadAction = {
  type: 'SAVE_PAYLOAD' | 'CLEAR';
  payload: PayloadType;
};

type Action = PayloadAction;

type Dispatch = (action: Action) => void;

type State = {
  coordinates: string;
};

type FakePinProviderProps = { children: React.ReactNode };

const FakePinStateContext = React.createContext<State>(undefined!);
const FakePinDispatchContext = React.createContext<Dispatch>(undefined!);

function tooltipReducer(state: State, action: Action) {
  switch (action.type) {
    case 'SAVE_PAYLOAD': {
      let payload = action.payload;

      return {
        ...state,
        ...payload,
      };
    }
    case 'CLEAR': {
      return {
        coordinates: '',
      };
    }
  }
}

function FakePinProvider({ children }: FakePinProviderProps) {
  const initialState = {
    coordinates: '',
  };

  const [state, dispatch] = React.useReducer(tooltipReducer, initialState);

  return (
    <FakePinStateContext.Provider value={state}>
      <FakePinDispatchContext.Provider value={dispatch}>{children}</FakePinDispatchContext.Provider>
    </FakePinStateContext.Provider>
  );
}

const useFakePinState = () => React.useContext(FakePinStateContext);
const useFakePinDispatch = () => React.useContext(FakePinDispatchContext);

export { FakePinProvider, useFakePinDispatch, useFakePinState };
